export default "__VITE_ASSET__CWO24YSS__"